import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { Sidebar } from '@/components/layout/Sidebar';
import { RequireAuth } from '@/components/layout/RequireAuth';
import { Analytics, Channels, Contacts, ConversationsV2, Dashboard, FlowEditor, Flows, Settings, Templates, TemplatesByChannel } from '@/pages';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { Login } from '@/pages/Login';
import { ResetPassword } from '@/pages/ResetPassword';
import '@/styles/globals.css';

const isAuthDisabled = (import.meta as any)?.env?.VITE_DISABLE_AUTH === 'true';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={isAuthDisabled ? <Dashboard /> : <Login />} />
        <Route path="/forgot-password" element={isAuthDisabled ? <Dashboard /> : <ForgotPassword />} />
        <Route path="/reset-password" element={isAuthDisabled ? <Dashboard /> : <ResetPassword />} />

        {/* Protected routes */}
        <Route element={<RequireAuth />}>
          <Route
            path="/"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Dashboard />
                </main>
              </div>
            }
          />

          <Route
            path="/channels"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Channels />
                </main>
              </div>
            }
          />

          <Route
            path="/flows"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Flows />
                </main>
              </div>
            }
          />

          <Route
            path="/flows/:id"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <FlowEditor />
                </main>
              </div>
            }
          />

          <Route
            path="/conversations/:id?"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <ConversationsV2 />
                </main>
              </div>
            }
          />

          <Route
            path="/templates"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <TemplatesByChannel />
                </main>
              </div>
            }
          />

          <Route
            path="/templates-manager"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Templates />
                </main>
              </div>
            }
          />

          <Route
            path="/contacts"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Contacts />
                </main>
              </div>
            }
          />

          <Route
            path="/analytics"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Analytics />
                </main>
              </div>
            }
          />

          <Route
            path="/settings"
            element={
              <div className="app-shell">
                <Sidebar />
                <main className="app-main">
                  <Settings />
                </main>
              </div>
            }
          />
        </Route>
      </Routes>

      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: 'var(--color-white)',
            color: 'var(--color-gray-900)',
            border: '1px solid var(--color-gray-200)',
            borderRadius: 'var(--radius-md)',
          },
        }}
      />
    </Router>
  );
}

export default App;
